import React from "react";
import { List, ListItemText, ListItemIcon, Typography, Box, ListItemButton } from "@mui/material";
import { boxStyle } from "../../../theme";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import GroupIcon from '@mui/icons-material/Group';
import TelegramIcon from '@mui/icons-material/Telegram';
import PasswordIcon from '@mui/icons-material/Password';
import RouterIcon from '@mui/icons-material/Router';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';

const SettingsCard = ({ selected, setSelected}) => {

  const Item = ({icon, text, toSetting}) => (
    <ListItemButton
      onClick={() => setSelected(toSetting)}
      sx={{color: selected === toSetting && "#5B9CA9"}}
    >
      <ListItemIcon sx={{ color: 'inherit' }}>
        {icon}
      </ListItemIcon>
      <ListItemText>
        <Typography>{text}</Typography>
      </ListItemText>
    </ListItemButton>
  )

  return (
    <Box sx={{...boxStyle, height: "auto"}}>
      <Typography variant="h4">Settings</Typography>
      <List component={"nav"} aria-label="settings options">
        <Item icon={<AccountCircleIcon />} text="Profile" toSetting={"profile"}/>
        <Item icon={<GroupIcon />} text={"Accounts Authorizzation"} toSetting={"account_auth"}/>
        <Item icon={<PasswordIcon />} text={"Licenses"} toSetting={"licenses"}/>
        <Item icon={<LibraryAddIcon />} text={"Add LECS"} toSetting={"add_lecs"}/>
        <Item icon={<RouterIcon />} text={"Devices"} toSetting={"devices"}/>
        <Item icon={<TelegramIcon />} text={"Telegram"} toSetting={"telegram"}/>
      </List>
    </Box>
  );
};

export default SettingsCard;


/* 
<Box sx={[boxStyle, { p: 2, minWidth: {xs: 275 , md: 275}}]}>
        <Typography variant="h4">Settings</Typography>
        <List component="nav" aria-label="settings options">
          <ListItem onClick={() => {setToViewAccountAutorization(false); setUser('')}}>
            <ListItemIcon>
              <AccountCircleIcon />
            </ListItemIcon>
            <ListItemText
              primary="Profile"
              sx={{
                color: ToViewAccountAutorization ? 'white' : "#5B9CA9",
                "&:hover": {
                  color: "#73ccd7",
                  cursor: "pointer",
                },
              }}
            />
          </ListItem>
          <ListItem onClick={() => {setToViewAccountAutorization(true); setUser('')}}>
            <ListItemIcon>
              <GroupIcon />
            </ListItemIcon>
            <ListItemText
              primary="Accounts Authorization"
              sx={{
                color: ToViewAccountAutorization ? "#5B9CA9" : 'white' ,
                "&:hover": {
                  color: "#73ccd7",
                  cursor: "pointer",
                },
              }}
            />
          </ListItem>
        </List>
    </Box>
*/